import Navbar from '@/components/feature/Navbar';
import HeroSection from '@/components/feature/HeroSection';
import AboutSection from '@/components/feature/AboutSection';
import ServicesSection from '@/components/feature/ServicesSection';
import WhyChooseSection from '@/components/feature/WhyChooseSection';
import ContactSection from '@/components/feature/ContactSection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <div className="relative bg-biodata-dark min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <WhyChooseSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}